import type { Cart } from "@packages/sdk";
import { endOfDay } from "date-fns/endOfDay";
import { isAfter } from "date-fns/isAfter";

import type { Payment } from "../types/payment.types";

type GetTrialTypeProps = { cart?: Cart };

export const getTrialType = ({
  cart,
}: GetTrialTypeProps): Payment["trialType"] => {
  if (cart) {
    if (cart.intro_offer) return "paid";

    if (
      cart.trial_end_date &&
      isAfter(endOfDay(new Date(cart.trial_end_date)), endOfDay(new Date()))
    )
      return "free";
  }

  return null;
};
